import FormFieldRule from "./FormFieldRule";
import FormFieldType from "./FormFieldType";

export default class FormField {
    public id: string = "";
    public title: string = "";
    public type: FormFieldType = FormFieldType.Text;
    public required: boolean = false;
    public hide: boolean | null = null;
    public mandatoryErrorMessage: string = "";
    public config: any = null;
    public rules: FormFieldRule[] | null = null;
}